import { NgModule } from "@angular/core";
import { FocusingDirective } from "./focusing.directive";

@NgModule({
    declarations: [FocusingDirective],
    exports: [FocusingDirective]
})
export class FocusingModule {

}